// extracted by mini-css-extract-plugin
module.exports = {"root":"AccountLayout_root__229z7","tabItem":"AccountLayout_tabItem__1bbA5","content":"AccountLayout_content__ed6TF"};